import { QueryClient } from "@tanstack/react-query";

const expires = 1000 * 60 * 60 * 24; // 24 hours

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: expires,
    },
    mutations: {
      onError: (error) => {
        console.log(error);
      },
    },
  },
});
